import Header from './Header';
import Footer from './Footer';

const AdminLayout = ({ children }) => {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
};

export default AdminLayout;
